import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, phoneRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.params && location.params.id) {
      getEstablishment();
    } else {
      history.push('/establishment');
    }
  }, []);

  const back = () => {
    history.goBack();
  };

  const getEstablishment = () => {
    setLoading(true);
    AxiosInstance.get('/establishment/' + location.params.id)
      .then((response) => {
        let inputValues = {
          name: response.data.name,
          category: response.data.category,
          region: response.data.region,
          email: response.data.email,
          phone: response.data.phone,
          image: response.data.image,
        };
        updateFormState(inputValues);
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_GET_ESTABLISHMENT'), '', 'error');
        history.push('/establishment');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateEstablishment = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('name', formState.inputValues.name);
    formData.append('category', formState.inputValues.category);
    formData.append('region', formState.inputValues.region);
    formData.append('email', formState.inputValues.email);
    formData.append('phone', formState.inputValues.phone);
    if (formState.inputValues.image instanceof File) {
      formData.append('image', formState.inputValues.image);
    }

    AxiosInstance({
      method: 'patch',
      url: '/establishment/' + location.params.id,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        Swal.fire(t('establishment.SUCCESS_UPDATE_ESTABLISHMENT'), '', 'success');
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_UPDATE_ESTABLISHMENT'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const inputValues = {
    name: { value: '', validate: { notEmpty: true, required: true } },
    category: { value: '', validate: { notEmpty: true, required: true } },
    region: { value: '', validate: { notEmpty: true, required: true } },
    email: { value: '', validate: { notEmpty: true, required: true, pattern: emailRegex } },
    phone: { value: '', validate: { notEmpty: true, required: true, pattern: phoneRegex } },
    image: { value: '', validate: { required: false } },
  };

  const { formState, submitHandler, updateFormState, field } = FormState(inputValues, updateEstablishment);

  return {
    submitHandler,
    back,
    loading,
    field,
  };
};

export default useForm;
